import React, { useState } from 'react';
import PlacementsTable from '../../components/PlacementsTable';
import { TEAM_LABELS } from '../../config';
import { addDays, fmtDate, isoDate, useFetch } from '../../hooks';
import { Alert, Card, Chip, Input, Skeleton, Stat } from '../../ui/basics';

const PRESETS = [7, 14, 30, 60, 90];

export default function ProjectedEnds({ org, lead }) {
  const today = isoDate(new Date());
  const [until, setUntil] = useState(isoDate(addDays(new Date(), 30)));
  const [team, setTeam] = useState('');
  const valid = until >= today;
  const { data, loading, error } = useFetch(valid ? 'reports/projected-ends/' : null, { organization: org, lead, until });
  const days = Math.round((new Date(until) - new Date(today)) / 86400000);

  return (
    <div className="stack">
      <Card title="Projected ends" subtitle={`Candidates whose projected end falls between today and ${fmtDate(until)}`}
        actions={<div className="row">
          {PRESETS.map((n) => <Chip key={n} on={days === n} onClick={() => setUntil(isoDate(addDays(new Date(), n)))}>Next {n} days</Chip>)}
          <Input type="date" min={today} style={{ width: 150 }} invalid={!valid} value={until} onChange={(e) => setUntil(e.target.value)} aria-label="Until date" />
        </div>}>
        {error && <Alert>{error}</Alert>}
        {!valid ? <Alert tone="warning">{until ? 'Choose a date that is today or later.' : 'Choose an end date for the window.'}</Alert> : loading || !data ? <Skeleton h={90} /> : (
          <div className="grid cols-4">
            <Stat label="Total" value={data.total} sub="ending in this window" onClick={() => setTeam('')} />
            {Object.entries(data.teams).map(([t, count]) => (
              <Stat key={t} label={TEAM_LABELS[t]} value={count} sub={team === t ? 'Showing below' : 'Click to filter the list'} onClick={() => setTeam(team === t ? '' : t)} />
            ))}
          </div>
        )}
      </Card>
      {valid && (
        <Card flush title={`Candidates ending by ${fmtDate(until)}${team ? ` · ${TEAM_LABELS[team]}` : ''}`}>
          <PlacementsTable key={`${until}-${team}`} fixed={{ organization: org, lead }} showProjected initialSize={10}
            initialFilters={{ projected_from: today, projected_to: until, ...(team ? { lead: team } : {}) }} />
        </Card>
      )}
    </div>
  );
}
